import { useBaseCrudService } from 'framework/crud';
import { FormFieldsData } from 'framework/form';
import { useKernelApi } from 'infrastructure/api';
import crmStrategyNoteValidation from './form/crmStrategyNoteValidation';
import { StrategyDto } from './types';

export const CREATE_STRATEGY_NOTE_PERMISSION = 'CREATE_STRATEGY_NOTE';
export const READ_STRATEGY_NOTE_PERMISSION = 'READ';
export const UPDATE_STRATEGY_NOTE_PERMISSION = 'UPDATE';
export const DELETE_STRATEGY_NOTE_PERMISSION = 'DELETE';

export const STRATEGY_NOTE_CREATED = 'STRATEGY_NOTE_CREATED';
export const CRMTimelineType = {
  STRATEGY: 'strategy',
};

const useCrmStrategyNoteService = () => {
  const {
    deleteById,
    getPermissions,
    update: baseUpdate,
  } = useBaseCrudService<StrategyDto>({
    listResourceUrl: '/crm/strategy-notes',
    singleResourceUrl: '/crm/strategy-notes/:id',
    useService: useKernelApi,
  });

  const update = async (id: StringOrNumber, data: FormFieldsData) => {
    const response = await baseUpdate(id, data);

    return {
      ...response,
      isPinned: true,
    };
  };

  return {
    getValidationSchema: () => Promise.resolve(crmStrategyNoteValidation),
    deleteById,
    getPermissions,
    update,
  };
};

export default useCrmStrategyNoteService;
